export const DOWNLOAD_FINAL_CHARGES_REPORT_REQUEST = "DOWNLOAD_FINAL_CHARGES_REPORT_REQUEST";
export const DOWNLOAD_FINAL_CHARGES_REPORT_SUCCESS = "DOWNLOAD_FINAL_CHARGES_REPORT_SUCCESS";
export const DOWNLOAD_FINAL_CHARGES_REPORT_FAILURE = "DOWNLOAD_FINAL_CHARGES_REPORT_FAILURE";
export const DOWNLOAD_FINAL_CHARGES_REPORT_RESET = "DOWNLOAD_FINAL_CHARGES_REPORT_RESET";
export const downloadFinalChargesReportRequest = (payload) => ({
    type: DOWNLOAD_FINAL_CHARGES_REPORT_REQUEST,
    payload,
});
export const downloadFinalChargesReportSuccess = (payload) => ({
    type: DOWNLOAD_FINAL_CHARGES_REPORT_SUCCESS,
    payload,
});
export const downloadFinalChargesReportFailure = (payload) => ({
    type: DOWNLOAD_FINAL_CHARGES_REPORT_FAILURE,
    payload,
});
export const downloadFinalChargesReportReset = () => ({
    type: DOWNLOAD_FINAL_CHARGES_REPORT_RESET,
});
